<div *ngIf="banner" [style.backgroundColor]="banner.color" class="banner">
	{{banner.name}}
</div>